<template>
  <div class="container">
    <AppBar immersive />
    <UITemplate
      v-if="data"
      :data="data"
      :current-notify-key="currentNotifyKey"
      @reTry="reTry"
    />
    <Loading v-else />
  </div>
</template>

<script>
import { loadHbridge } from '@/utils/globalLoader';
import Loading from '@/components/empty/Loading';
import { Notify } from 'vant';
import { checkV2 } from '@/api/cabinet';
import { dispatchRenderEvent } from '@/utils/preRender';
import { PV } from '@/utils/ubtUtils';
import UITemplate from './UITemplate';

let _pageIsUnmount = false;

const _check = (params) => checkV2(params).then((res) => {
  if (process.env.VUE_APP_ENV !== 'pro') {
  // eslint-disable-next-line no-console
    console.log('async response: ');
    // eslint-disable-next-line no-console
    console.log(res);
  }
  Notify.clear();
  if (_pageIsUnmount) {
    throw new Error('页面已销毁');
  }
  if ((!res || !res.data)) {
    return _check(params);
  }

  let data;
  if (res.data.data && res.data.data.notifyFlag === 0) {
    // async网关推送消息比缓存消息多一层结构,识别到data 并包含notifyFlag后，则认为res.data.data是业务消息体
    data = res.data;
  }
  data = res;

  // 返回结果的curNotifyKey 与 请求参数的notifyKey不相等，则忽略请求，兼容网关推动消息不识别notifyKey bug
  if (data.data.curNotifyKey !== params.notifyKey) {
    return _check(params);
  }

  return data;
})
  .catch(() => new Promise((resolve, reject) => {
    Notify({
      message: '设备连接失败，正在重连中',
      duration: 0,
    });
    setTimeout(() => {
      if (_pageIsUnmount) {
        reject(new Error('页面已销毁'));
      } else {
        resolve(_check(params));
      }
    }, 5000);
  }));


export default {
  components: { Loading, UITemplate },
  data() {
    window.temp = this;
    // eslint-disable-next-line no-console
    console.log(`请输入"temp.data = xxx,模拟数据", 如：
    
    temp.data = {
        title: '换第一块电池，<span style="color: #08f;">12 号</span>仓门已打开', // 主标题
        info: '请放入旧电池并关上仓门', // 副标题
        loadingType: 2, // 1: 进度条， 2: 倒计时
        countDownTime: 120, // 倒计时剩余时间，单位秒，loadingType有值时生效
        imageType: 1, // 1：电柜  2：电池（灰））
        subTitle: '<i style="color: #FB990F" class="hb-icon hb-icon-warning"></i>自动为您匹配最高电量电池',
        showFeedBack: true, // 释放显示反馈入口
        gridNo: 1, // 格口号
        actions: [
          {
            btnText: '换电完成',
            action: 1, // 1:重新扫码(reScan)   2:开仓重试（reTry）  3:换电完成/返回(goBack)   4:查看押金（checkDeposit）
          },
          {
            btnText: '开仓重试',
            action: 1, // 1:重新扫码(reScan)   2:开仓重试（reTry）  3:换电完成/返回(goBack)   4:查看押金（checkDeposit）
          },
        ],
      }`);
    return {
      data: {
        title: '设备连接中...', // 主标题
      },
      currentNotifyKey: '',
    };
  },
  async created() {
    PV.unlock();
    if (window.__PRERENDER_INJECTED) {
      dispatchRenderEvent();
      return;
    }
    _pageIsUnmount = false;
    this.listene({
      notifyKey: this.$route.query.notifyKey,
    });
    const { env, Native } = await loadHbridge();
    if (env.isAndroid && env.isEasyBikeApp) {
      // 修改状态栏颜色
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBarColor',
        params: { colorCode: '#f7f9fa' },
      });
    }
  },
  destroyed() {
    _pageIsUnmount = true;
  },
  methods: {
    async listene(params) {
      this.currentNotifyKey = params.curNotifyKey;
      const { data: { isEnd = true, nextNotifyKey, ...data } } = await _check(params) || {};
      this.data = data;
      if (!isEnd) {
        this.listene({
          notifyKey: nextNotifyKey,
        });
      }
    },
    reTry() {
      // 重新开仓时
      this.data = {
        title: '重新开仓中...', // 主标题
      };
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #f7f9fa;
}
</style>
